import { createReducer } from '../../store.model';
import { CoachingCoverageContext } from '../coaching-coverage/coaching-coverage.model';
import { FLOAPerson } from '../oa/models/floa.model';

import { checkInsightSummaryData } from './function/check-insight-summary-data.function';
import {
    ActionType,
    ClearStateAction,
    InitAction,
    ReloadResultAction,
    SelectKpiAction,
    SelectPeriodTypeAction,
    SelectUserAction,
    SelectUserResultAction,
} from './insight-widget.action';
import { defaultState, RootState } from './insight-widget.state';
import { KpiType } from './model/kpi-type.model';

const { builder, reducer } = createReducer<ActionType, RootState>(
    defaultState(),
);

builder
    .add<InitAction>(ActionType.COACHING_INSIGHT__RELOAD, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: true,
            },
        };
    })
    .add<ReloadResultAction>(
        ActionType.COACHING_INSIGHT__RELOAD_RESULT,
        (state, action) => {
            const ret = checkInsightSummaryData({
                insightSummaryData: action.payload.insightSummaryData,
                periodTypeId: action.payload.periodTypeId,
                periodDate: action.payload.periodDate,
                kpiTypeId: action.payload.kpiTypeId,
            });

            const nextCoverageContext: CoachingCoverageContext = {
                user: state.user,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                periodType:
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    ret.selectedPeriodType &&
                    ret.selectedPeriodType.periodTypeId,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                periodDate: new Date(
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    ret.selectedPeriodType &&
                        ret.selectedPeriodType.periodTypeDate,
                ),
            };

            let oaUser: FLOAPerson = null;
            try {
                const oa = ret.kpis.find(
                    (e) => e.kpiTypeId === KpiType.OPPORTUNITY_ALIGNMENT,
                );
                if (oa) {
                    oaUser = {
                        oaScore: oa.kpiValue,
                        oaThresholdColour: oa.kpiColour,
                    };
                }
            } catch {}

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: false,
                },
                kpis: ret.kpis,
                periodTypes: ret.periodTypes,
                selectedPeriodType: ret.selectedPeriodType,
                selectedKpi: ret.selectedKpi,
                coverageContext: nextCoverageContext,
                oaUser,
            };
        },
    );

builder
    .add<SelectUserAction>(
        ActionType.COACHING_INSIGHT__SELECT_USER,
        (state, action) => {
            sessionStorage.setItem(
                'coachingInsight-userId',
                action.payload.userId.toString(),
            );
            return {
                ...state,
                authUserId: action.payload.authUserId,
            };
        },
    )
    .add<SelectUserResultAction>(
        ActionType.COACHING_INSIGHT__SELECT_USER_RESULT,
        (state, action) => {
            const nextCoverageContext: CoachingCoverageContext = {
                user: action.payload.user,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                periodType:
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    state.selectedPeriodType &&
                    state.selectedPeriodType.periodTypeId,
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                periodDate: new Date(
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    state.selectedPeriodType &&
                        state.selectedPeriodType.endDate,
                ),
            };

            return {
                ...state,
                user: action.payload.user,
                userImage: action.payload.userImage,
                coverageContext: nextCoverageContext,
            };
        },
    );

builder.add<SelectPeriodTypeAction>(
    ActionType.COACHING_INSIGHT__SELECT_PERIOD_TYPE,
    (state, action) => {
        return {
            ...state,
            selectedPeriodType: action.payload.periodType,
        };
    },
);

builder.add<SelectKpiAction>(
    ActionType.COACHING_INSIGHT__SELECT_KPI,
    (state, action) => {
        return {
            ...state,
            selectedKpi: action.payload.kpi,
        };
    },
);

builder.add<ClearStateAction>(ActionType.COACHING_INSIGHT__CLEAR_STATE, () => {
    sessionStorage.removeItem('coachingInsight-userId');
    return defaultState();
});

export default {
    coachingInsight: {
        root: reducer,
    },
};
